import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'customhtmlsanitizer'
})
export class CustomhtmlsanitizerPipe implements PipeTransform {

  constructor(private sanitixer: DomSanitizer){}

  transform(value: string): any {
    return this.sanitixer.bypassSecurityTrustHtml(value);
  }

}
